/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Unit_Bodyweight_PlusInputs */

const en_us2_workout_logging_unit_bodyweight_plus = /** @type {(inputs: Workout_Logging_Unit_Bodyweight_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg added`)
};

const pt_br2_workout_logging_unit_bodyweight_plus = /** @type {(inputs: Workout_Logging_Unit_Bodyweight_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg extra`)
};

const es_419_workout_logging_unit_bodyweight_plus = /** @type {(inputs: Workout_Logging_Unit_Bodyweight_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg extra`)
};

const pt_pt2_workout_logging_unit_bodyweight_plus = /** @type {(inputs: Workout_Logging_Unit_Bodyweight_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg extra`)
};

const fr_fr2_workout_logging_unit_bodyweight_plus = /** @type {(inputs: Workout_Logging_Unit_Bodyweight_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg ajoutés`)
};

const de_de2_workout_logging_unit_bodyweight_plus = /** @type {(inputs: Workout_Logging_Unit_Bodyweight_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg extra`)
};

const it_it2_workout_logging_unit_bodyweight_plus = /** @type {(inputs: Workout_Logging_Unit_Bodyweight_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg aggiunti`)
};

/**
* | output |
* | --- |
* | "kg added" |
*
* @param {Workout_Logging_Unit_Bodyweight_PlusInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_unit_bodyweight_plus = /** @type {((inputs?: Workout_Logging_Unit_Bodyweight_PlusInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Unit_Bodyweight_PlusInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_unit_bodyweight_plus(inputs)
	if (locale === "es-419") return es_419_workout_logging_unit_bodyweight_plus(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_unit_bodyweight_plus(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_unit_bodyweight_plus(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_unit_bodyweight_plus(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_unit_bodyweight_plus(inputs)
	return en_us2_workout_logging_unit_bodyweight_plus(inputs)
});
export { workout_logging_unit_bodyweight_plus as "workout-logging.unit_bodyweight_plus" }